import { render, staticRenderFns } from "./GKTag.vue?vue&type=template&id=2defa6fc&scoped=true&"
import script from "./GKTag.vue?vue&type=script&lang=js&"
export * from "./GKTag.vue?vue&type=script&lang=js&"
import style0 from "./GKTag.vue?vue&type=style&index=0&id=2defa6fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2defa6fc",
  null
  
)

export default component.exports